module.exports = __webpack_public_path__ + "img/qp_logo.5b4e06ac.svg";